import { Component, Input, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { City } from 'src/typings';
import { CityService } from '../city.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent {
  @Input() set city(payload: City | undefined) {
    this._city = payload;
    this.cityForm.controls.description.setValue(payload?.description);
  }

  private _city: City | undefined;

  get city() {
    return this._city;
  }

  doneEvent: EventEmitter<void> = new EventEmitter();

  cityForm = this.fb.group({
    description: new UntypedFormControl()
  });

  constructor(private cityService: CityService, private fb: UntypedFormBuilder) {}

  async create() {
    await this.cityService
      .create({
        description: this.cityForm.value.description
      })
      .toPromise();
    this.doneEvent.emit();
  }

  async update() {
    if (!this.city) return;
    await this.cityService
      .update({
        id: this.city.id,
        description: this.cityForm.value.description
      })
      .toPromise();
    this.doneEvent.emit();
  }

  save() {
    if (this.city) return this.update();
    return this.create();
  }
}
